import type { Goal } from '@/domain'

import type { Database } from './database.types'
import type { CentimeClient } from './supabase'

type GoalRow = Database['public']['Tables']['goals']['Row']
type GoalInsert = Database['public']['Tables']['goals']['Insert']

export function goalFromRow(row: GoalRow): Goal {
  return {
    id: row.id,
    envelopeId: row.envelope_id,
    name: row.name,
    targetAmount: row.target_amount,
    targetDate: row.target_date,
    archivedAt: row.archived_at,
  }
}

export function goalToRow(goal: Goal): GoalInsert {
  return {
    id: goal.id,
    envelope_id: goal.envelopeId,
    name: goal.name.trim(),
    target_amount: goal.targetAmount,
    target_date: goal.targetDate,
    archived_at: goal.archivedAt,
  }
}

/** Objectifs en cours (les objectifs archivés restent en base, hors de la liste). */
export async function listGoals(client: CentimeClient): Promise<Goal[]> {
  const { data, error } = await client
    .from('goals')
    .select('*')
    .is('archived_at', null)
    .order('created_at')
  if (error) throw error
  return data.map(goalFromRow)
}

export async function saveGoal(client: CentimeClient, goal: Goal): Promise<Goal> {
  const { data, error } = await client.from('goals').upsert(goalToRow(goal)).select('*').single()
  if (error) throw error
  return goalFromRow(data)
}
